/**
 * [BLURY] | 🥭 BlurPanel
 * The gaussian blur pass and its tone controls.
 * @build 13.09.26
 * @updated 13.09.26 PHT
 * @author TONYTONY Sàrl
 */
import { useStudio } from '@/state/useStudio';
import { Section, SectionNote } from '../ui/Section';
import { Slider } from '../ui/Slider';

export function BlurPanel() {
  const composition = useStudio(s => s.composition);
  const setNumeric = useStudio(s => s.setNumeric);

  return (
    <Section badge={2} title="Gaussian blur">
      <Slider
        label="radius"
        value={composition.blur}
        min={0}
        max={300}
        format={v => `${v} px`}
        onChange={v => setNumeric('blur', v)}
      />
      <Slider
        label="saturation"
        value={composition.sat}
        min={0}
        max={200}
        format={v => `${v}%`}
        onChange={v => setNumeric('sat', v)}
      />
      <Slider
        label="contrast"
        value={composition.con}
        min={50}
        max={160}
        format={v => `${v}%`}
        onChange={v => setNumeric('con', v)}
      />
      <SectionNote>
        Blur is rendered on an over-scanned buffer so edges stay full-bleed instead of fading out.
      </SectionNote>
    </Section>
  );
}
